import { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "@/lib/links";

export const defaultPricing = { monthly: { price: 79.99, others: 199 }, yearly: { price: 899.99, others: 2000 } };

export const money = (n) => {
  const whole = Number.isInteger(n);
  return `$${n.toLocaleString("en-US", { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 })}`;
};

export const savingsLabel = (plan, { price, others }) => {
  const diff = others - price;
  if (diff <= 0) return null;
  if (plan === "monthly") return `Save ${money(Math.round(diff))} every month`;
  const floored = Math.floor(diff / 100) * 100;
  return floored >= 100 ? `Save over ${money(floored)} a year` : `Save ${money(Math.round(diff))} a year`;
};

export const usePricing = () => {
  const [pricing, setPricing] = useState(defaultPricing);
  useEffect(() => {
    axios.get(`${API_URL}/pricing`).then(({ data }) => setPricing(data)).catch(() => {});
  }, []);
  return pricing;
};
